const isBot = (userAgent) => {
    const botPatterns = [
        'Googlebot',
        'Googlebot-Mobile',
        'Googlebot-Image',
        'bingbot',
        'adidxbot',
        'MSNBot',
        'BingPreview',
        'Yahoo! Slurp',
        'DuckDuckBot',
        'Baiduspider',
        'YandexBot',
        'YandexImages',
        'YandexMobileBot',
        'DotBot',
        'Cookiebot',
        'facebookexternalhit',
        'facebookcatalog',
        'Slackbot-LinkExpanding',
        'Facebot',
        'TelegramBot',
        'Discordbot',
        'AdsBot-Google',
        'Instagram',
        'WhatsApp',
        'LinkedInBot',
        'Twitterbot',
        'Pinterestbot',
        'Pinterest',
        'TikTokBot',
        'Chrome-Lighthouse',
        'Lighthouse',
        'Pagespeed',
        'Google Page Speed Insights',
        'Google-InspectionTool',
        'Google Web Preview',
        'Google-Structured-Data-Testing-Tool',
        'Mediapartners-Google',
        'W3C',
        'Schema-Markup-Validator',
        'GTmetrix',
        'UptimeRobot',
        'Pingdom',
        'Pingdom.com_bot_version_',
        'SemrushBot',
        'AhrefsBot',
        'MJ12bot',
        'HeadlessChrome',
        'Screaming Frog',
        'Screaming Frog SEO',
        'Google Favicon', // Google’s favicon bot
    ];
    const botRegex = new RegExp(botPatterns.join('|'), 'i');
    return botRegex.test(userAgent);
};
var isBot$1 = {};

export { isBot$1 as default, isBot };
//# sourceMappingURL=isBot.js.map
